
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class FormErrorPage extends Vue {
    public get title() {
        if (this.$route.name === 'alreadyAnswered') return this.$t('form_already_answered_message');
        if (this.$route.name === 'formExpired') return this.$t('expired_survey_message');
        return this.$t('form_unavailable_message');
    }

    public get description() {
        if (this.$route.name === 'alreadyAnswered') return this.$t('form_already_answered_description');
        if (this.$route.name === 'formExpired') return this.$t('expired_survey_description');
        return this.$t('form_unavailable_description');
    }
}
